var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-form',{ref:"editForm",attrs:{"lazy-validation":"","onSubmit":"return false"}},[_c('html-editor',{attrs:{"height":300,"mapplicOptionList":_vm.mapplicOptionList},model:{value:(_vm.pagePartOptions.html),callback:function ($$v) {_vm.$set(_vm.pagePartOptions, "html", $$v)},expression:"pagePartOptions.html"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }